import { RiComputerLine } from "@remixicon/react";
import React from "react";
import { Themes, useTheme } from "../../contexts/Theme";
import { useConfirm } from "../confirm/Confirm";
import Button from "../theme/button/Button";
import Icon from "../theme/icon/Icon";
import Styles from "./Workflow.module.scss";
import useRouting from "../../contexts/Routing";

export function WorkflowComingSoon({ settingPage }: {settingPage?: string}) {
    const theme = useTheme();
    const { historyPush, Paths } = useRouting();

    return (
        <div className={Styles["workflow-coming-soon"]}>

            <Icon.Automation size="xxlarge" background="warning" variant="warning" className="p-1" isRounded />

            <h4 className={Styles.title}>Coming Soon</h4>
            <p className={Styles["more-info"]}>
                We are currently working on redesigning our automations using the new UI. However, this is
                not quite done. To modify automations, please use the legacy version of Foqal.
            </p>

            <Button
                onClick={() => {
                    theme.setTheme(Themes.DEFAULT);
                    if (settingPage) {
                        historyPush(Paths.ADMINISTRATOR_SETTING, { setting: settingPage || "/settings" });
                    }
                }}
                prefixIcon={<RiComputerLine />}
                variant="outline-blue"
            >
                Switch to Legacy
            </Button>

        </div>
    );
}
WorkflowComingSoon.defaultProps = {
    settingPage: undefined,
};

export default function useWorkflowComingSoon() {
    return useConfirm({
        size: "lg",
        body: <WorkflowComingSoon />,
    });
}
